import Vue from 'vue';
import App from './App.vue';

import axios from 'axios';
import VueRouter from 'vue-router';
import VuePapaParse from 'vue-papa-parse';
import i18n from '@/plugins/i18n';

import './scss/main.scss';
import 'leaflet/dist/leaflet.css';
import {Icon} from 'leaflet';
import BootstrapVue from 'bootstrap-vue'; // style ds custom

Vue.use(VuePapaParse);
Vue.use(BootstrapVue);
Vue.use(VueRouter);

const router = new VueRouter({});

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');